

/**
 * Sample class for CloudProvider.
 */
export interface CloudProvider {

    /**
     * Identify this CloudProvider within the CloudProviders that belong to an user
     */
    name: string;

    /**
     * The Cloud Provider code
     */
    api: string;

    /**
     * The User.uname that owns this provider
     */
    owner?: string;

}